import { chartText } from './chartText';

const LABEL_KEYS = {
  product: 'versionConflict.product',
  sizeChart: 'versionConflict.sizeChart',
  attribute: 'versionConflict.attribute',
  photo: 'versionConflict.photo',
};

export function versionConflictLabel(type, rawLabel) {
  const fallback = rawLabel || '模板';
  return chartText(LABEL_KEYS[type] || 'versionConflict.template', fallback);
}

export function versionConflictUpdatedReload(label) {
  return chartText(
    'versionConflict.updatedReload',
    `${label}已被更新，请重新加载对应区域`,
    { label },
  );
}

export function versionConflictMissing(label) {
  return chartText(
    'versionConflict.missing',
    `${label}不存在或已删除`,
    { label },
  );
}

export function versionConflictToast(conflicts = [], labelFor = () => '模板') {
  if (!conflicts.length) {
    return chartText(
      'versionConflict.updatedByOther',
      '模板已被他人更新，请核对标出的字段后重新加载',
    );
  }
  const names = [...new Set(conflicts.map((item) => labelFor(item?.type)))].join('、');
  return chartText(
    'versionConflict.updatedCheck',
    `${names}已被更新，请核对标出的字段后重新加载`,
    { names },
  );
}
